import { TYPE_FETCH, TYPE_SUCCESS, TYPE_FAILURE, TYPE_UPDATE, TYPE_FETCH_ADMIN, TYPE_SUCCESS_ADMIN, TYPE_FAILURE_ADMIN, TYPE_UPDATE_ADMIN, TYPE_UPDATEALL_ADMIN } from "./../types"

const initialState = { isLoadingType: false, DataType: [], errorMessage: null, isLoadingTypeAdmin: false, DataTypeAdmin: [], errorMessageAdmin: null }

export default function typesReducer(state = initialState, action) {
    switch (action.type) {
        case TYPE_FETCH: {
            return { ...state, isLoadingType: true, DataType: [], errorMessage: null }
        }
        case TYPE_SUCCESS: {
            return { ...state, isLoadingType: false, DataType: action.payload, errorMessage: null }
        }
        case TYPE_FAILURE: {
            return { ...state, isLoadingType: false, errorMessage: action.error }
        }
        case TYPE_UPDATE: {
            return { ...state, DataType: [...state.DataType, action.payload] }
        }
        //Admin Create or Edit
        case TYPE_FETCH_ADMIN: {
            return { ...state, isLoadingTypeAdmin: true, errorMessageAdmin: null }
        }
        case TYPE_SUCCESS_ADMIN: {
            return { ...state, isLoadingTypeAdmin: false, DataTypeAdmin: action.payload, errorMessageAdmin: null }
        }
        case TYPE_FAILURE_ADMIN: {
            return { ...state, isLoadingTypeAdmin: false, errorMessageAdmin: action.error }
        }
        case TYPE_UPDATE_ADMIN: {
            return { ...state, DataTypeAdmin: [...state.DataTypeAdmin, action.payload] }
        }
        case TYPE_UPDATEALL_ADMIN: {
            return { ...state, isLoadingTypeAdmin: false, DataTypeAdmin: action.payload }
        }
        default:
            return state
    }
}